import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CurrencyInput, VoucherInput } from 'components/ui/Inputs';
import ValidationForm from 'components/ui/ValidationForm';

import SplitPayment from '../../SplitPayment';
import { handlePaymentSubmit } from '../../SplitPayment/SplitPayment.utils';
import { Errors } from '../../SplitPayment/SplitPayment.styles';

const PaperVoucherPayment = ({
  totalPriceToBePaid,
  onAmountChange,
  currentAmount,
  isOnHold,
  payAndConfirm,
  takeDeposit,
  addPayment,
  reference,
  currency,
  method,
  loading,
  isPutOnHoldWithDeposit
}) => (
  <ValidationForm
    fields={{ amount: currentAmount, voucherReference: '' }}
    validators={{
      amount: (values) => {
        const amount = Number(values.amount);

        return amount !== 0 && amount <= totalPriceToBePaid;
      },
      voucherReference: (values) => !!values.voucherReference && values.voucherReference.length <= 8
    }}
    overrideFields={{ amount: currentAmount }}
    validateInitialFields
  >
    {({ fields, onChange, invalidInputs, hasInvalidInputs, touchedInputs }) => {
      const handleSubmit = (e) => {
        e.preventDefault();

        handlePaymentSubmit({
          cashTendered: fields.amount,
          totalPriceToBePaid,
          payAndConfirm,
          takeDeposit,
          addPayment,
          isOnHold,
          bookingReference: reference,
          currency,
          method,
          externalReference: fields.voucherReference
        });
      };

      const handleChange = (e) => {
        onChange(e);

        if (onAmountChange) {
          onAmountChange(e.target.value);
        }
      };

      return (
        <SplitPayment
          title={<FormattedMessage id="payments.AmountToPayByPaperVoucher" />}
          subTitle={<FormattedMessage id="payments.canBeSplit" />}
          label={<FormattedMessage id="payments.recordPayment" />}
          loading={loading}
          disabled={hasInvalidInputs}
          onSubmit={handleSubmit}
        >
          <CurrencyInput
            name="amount"
            value={fields.amount}
            currency={currency}
            disabled={isPutOnHoldWithDeposit ? false : isOnHold}
            onChange={handleChange}
          />
          <VoucherInput
            message={<FormattedMessage id="payments.paperVoucherRef" />}
            name="voucherReference"
            value={fields.voucherReference}
            type="text"
            onChange={(e) => {
              onChange(e);
            }}
          />
          <Errors>
            {invalidInputs.amount && Number(fields.amount) === 0 && <FormattedMessage id="payments.amountZero" />}
            {invalidInputs.amount && Number(fields.amount) !== 0 && <FormattedMessage id="payments.amountTooLarge" />}
          </Errors>

          <Errors>
            {touchedInputs.voucherReference && invalidInputs.voucherReference && (
              <FormattedMessage id="payments.paperVoucherNumberIsNotValid" />
            )}
          </Errors>
        </SplitPayment>
      );
    }}
  </ValidationForm>
);

PaperVoucherPayment.propTypes = {
  currentAmount: PropTypes.string,
  onAmountChange: PropTypes.func,
  totalPriceToBePaid: PropTypes.number,
  loading: PropTypes.bool,
  isOnHold: PropTypes.bool,
  payAndConfirm: PropTypes.func,
  takeDeposit: PropTypes.func,
  addPayment: PropTypes.func,
  reference: PropTypes.string,
  currency: PropTypes.string,
  method: PropTypes.string,
  isPutOnHoldWithDeposit: PropTypes.bool
};

export default PaperVoucherPayment;
